import { createStyles, Theme } from '@material-ui/core/styles';

import { AlertMode, AlertType } from '@shared/components/alert';
import { colors, colours } from '@shared/theme/colours';

export const styles = ({ spacing, transitions }: Theme) =>
  createStyles({
    root: {
      position: 'relative',
    },
    content: {
      padding: spacing(3, 2.5),
      borderRadius: spacing(2),
      transition: `box-shadow ${transitions.duration.standard}s ${transitions.easing.easeInOut}`,
    },
    infoContainer: {
      flexWrap: 'nowrap',
    },
    icon: {
      flex: '0 0 auto',
      fontSize: 18,
      marginRight: spacing(2),
      blockSize: '20px',
    },
    closeIcon: {
      flex: '0 0 auto',
      fontSize: '1.2rem',
      marginLeft: spacing(2),
      color: colors.grey.icon, //TODO design review whether this should be inherited
      cursor: 'pointer',

      '&:hover': {
        color: colors.grey.dark,
      },
    },
    textActionsContainer: {
      flex: '1 1 auto',
    },
    title: {
      fontSize: 16,
      fontWeight: 600,
      display: 'inline-block',
      lineHeight: '20px',
      marginBottom: spacing(1),
    },
    text: {
      fontSize: 14,
      fontWeight: 400,
    },
    subText: {
      fontSize: 14,
      lineHeight: '20px',
    },
    actionsContainer: {
      marginTop: spacing(3),
      gap: 10,
    },
    button: {
      boxShadow: 'none',
      maxHeight: 24,

      '&:hover': {
        boxShadow: 'none',
      },
    },
    dropdownRoot: {
      '& .MuiInputBase-root': {
        maxHeight: 24,
      },
    },

    [AlertType.alert]: {
      '& $content': {
        border: `1px solid ${colours.error[200]}`,
        backgroundColor: colours.error[50],
        borderRadius: spacing(2),
        color: colours.error[700],
      },

      '& $icon': {
        color: colours.error[700],

        '& path': {
          stroke: colours.error[700],
        },
      },
    },
    [AlertType.grey]: {
      '& $content': {
        border: `1px solid ${colours.neutral[300]}`,
        backgroundColor: colours.solid.white,
        borderRadius: spacing(2),
        color: colours.neutral[700],
      },

      '& $icon': {
        color: colours.neutral[700],

        '& path': {
          stroke: colours.neutral[700],
        },
      },
    },
    [AlertType.info]: {
      '& $content': {
        border: `1px solid ${colours.brandNavy[300]}`,
        backgroundColor: colours.brandNavy[50],
        borderRadius: spacing(2),
        color: colours.brandNavy[700],
      },

      '& $icon': {
        color: colours.brandNavy[700],

        '& path': {
          stroke: colours.brandNavy[700],
        },
      },
    },
    [AlertType.infoTeal]: {
      '& $content': {
        border: `1px solid ${colours.brandTeal[500]}`,
        backgroundColor: colours.brandTeal[50],
        borderRadius: spacing(2),
        color: colours.brandTeal[700],
      },

      '& $icon': {
        color: colours.brandTeal[700],

        '& path': {
          stroke: colours.brandTeal[700],
        },
      },
    },
    [AlertType.lilac]: {
      '& $content': {
        border: `1px solid ${colours.lilac[500]}`,
        backgroundColor: colours.lilac[50],
        borderRadius: spacing(2),
        color: colours.lilac[700],
      },

      '& $icon': {
        color: colours.lilac[700],

        '& path': {
          stroke: colours.lilac[700],
        },
      },
    },
    [AlertType.success]: {
      '& $content': {
        border: `1px solid ${colours.success[200]}`,
        backgroundColor: colours.success[50],
        borderRadius: spacing(2),
        color: colours.success[700],
      },

      '& $icon': {
        color: colours.success[700],

        '& path': {
          stroke: colours.success[700],
        },
      },
    },
    [AlertType.warning]: {
      '& $content': {
        border: `1px solid ${colours.warning[300]}`,
        backgroundColor: colours.warning[50],
        borderRadius: spacing(2),
        color: colours.warning[700],
      },

      '& $icon': {
        color: colours.warning[700],

        '& path': {
          stroke: colours.warning[700],
        },
      },
    },
    [AlertMode.Default]: {},
    [AlertMode.Inline]: {
      '& $content': {
        border: 'none',
        borderRadius: 0,
      },

      '& $actionsContainer': {
        flexWrap: 'nowrap',
        marginTop: 0,
        marginLeft: spacing(2.5),
      },

      '& $icon': {
        display: 'inline-flex',
        alignItems: 'center',
      },

      '& $textActionsContainer': {
        flexDirection: 'row',
        flexWrap: 'nowrap',
        justifyContent: 'space-between',
        alignItems: 'center',
      },
    },
  });
